import { ChangeDetectionStrategy, Component, ErrorHandler, Input, OnInit } from '@angular/core'
import { FieldTree } from '@angular/forms/signals'

import { Platform } from '@angular/cdk/platform'
import { DateAdapter } from '@angular/material/core'
import { MatDatepicker } from '@angular/material/datepicker'

import { DateService } from '@lemon/core/service/date.service'

import { asetaArvo } from '../_jaettu-angular/_lomakkeet/arvon-muutokset'
import { LemonKuukausiDateAdapter } from '../_jaettu-angular/_material/LemonKuukausiDateAdapter'
import { LemonTranslationService } from '../_jaettu-angular/service/lemon-translation.service'

@Component({
  selector: 'app-asiakas-lisaa-eka-lasku-kuukausi',
  templateUrl: './asiakas-lisaa.pvm.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: LemonKuukausiDateAdapter, deps: [ErrorHandler, DateService, Platform, LemonTranslationService] },
  ],
  standalone: false,
})
export class AsiakasLisaaEkaLaskutuskuukausiComponent implements OnInit {
  @Input() kontrolli: FieldTree<Date | null>
  @Input() minMonth: Date

  constructor(private dateService: DateService) {}

  chosenMonthHandler(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    if (this.dateService.kuukausiaValissa(normalizedMonth, this.minMonth) > -1) {
      asetaArvo(this.kontrolli, normalizedMonth)
      this.kontrolli().markAsTouched()
    }
    datepicker.close()
  }

  naytaVirhe(laji: string) {
    const tila = this.kontrolli()
    return tila.errors().some(virhe => virhe.kind === laji) && (tila.dirty() || tila.touched())
  }

  ngOnInit() {}
}
